import { render } from "./ModalAddFile.vue?vue&type=template&id=a07d7934"
import script from "./ModalAddFile.vue?vue&type=script&lang=js"
export * from "./ModalAddFile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__